module.exports = __webpack_public_path__ + "static/media/bg-narahari-kr.ee7ad871.jpg";